export class PromoCode {
    constructor(element) {
        this.wrapper = $(element);

        this.setElementClasses();

        this.bonusesForm = this.wrapper.find('.' + this.BONUSES_BLOCK_CLASS);
        this.bonusesSubmit = this.wrapper.find('.' + this.BONUSES_SUBMIT_CLASS);
        this.bonusesInput = this.wrapper.find('.' + this.BONUSES_INPUT_CLASS);
        this.bonusesRemove = this.wrapper.find('.' + this.BONUSES_REMOVE_CLASS);

        this.promoCodeForm = this.wrapper.find('.' + this.PROMOCODE_BLOCK_CLASS);
        this.promoCodeSubmit = this.wrapper.find('.' + this.PROMOCODE_SUBMIT_CLASS);
        this.promoCodeInput = this.wrapper.find('.' + this.PROMOCODE_INPUT_CLASS);
        this.promoCodeRemove = this.wrapper.find('.' + this.PROMOCODE_REMOVE_CLASS);

        this.MAX_BONUSES = this.bonusesInput.attr('max');

        this.bind();
        this.promoCodeInputControl();
        this.BonusesInputControl();
    }
    setElementClasses() {
        this.BONUSES_BLOCK_CLASS = 'js-promo-code_bonus';
        this.BONUSES_SUBMIT_CLASS  = 'js-promo-code_bonus-submit';
        this.BONUSES_INPUT_CLASS = 'js-promo-code_bonus-input';
        this.BONUSES_REMOVE_CLASS = 'js-promo-code_bonus-remove';

        this.PROMOCODE_BLOCK_CLASS = 'js-promo-code_promo';
        this.PROMOCODE_INPUT_CLASS = 'js-promo-code_promo-input';
        this.PROMOCODE_SUBMIT_CLASS = 'js-promo-code_promo-submit';
        this.PROMOCODE_REMOVE_CLASS = 'js-promo-code_promo-remove';

        this.BUTTONS_WRAPPER_CLASS = 'js-promo-code_button-wrapper';

        this.WRAPPER_CLASS = 'form-group';
        this.ERROR_WRAPPER_CLASS = 'promo-code-fail';
        this.ERROR_TEXT_BLOCK = 'promo-code-error';
    }
    name() {
        return 'PromoCode';
    }
    bind() {
        this.bonusesInput.off('keypress').on('keypress', (event) => this.onBonusesInput.call(this, event));
        this.bonusesInput.off('keyup').on('keyup', (event) => this.checkBonusesValue.call(this, event));
        this.bonusesInput.off('change').on('change', (event) => this.BonusesInputControl.call(this, event));
        this.bonusesInput.off('input').on('input', (event) => this.BonusesInputControl.call(this, event));

        this.bonusesSubmit.off('click').on('click', (event) => this.onBonusesSubmit.call(this, event));
        this.promoCodeSubmit.off('click').on('click', (event) => this.onPromoCodeSubmit.call(this, event));

        this.promoCodeInput.off('keyup').on('keyup', (event) => this.promoCodeInputControl.call(this, event));
        this.promoCodeInput.off('keypress').on('keypress', (event) => this.promoCodeInputControl.call(this, event));
        this.promoCodeInput.off('change').on('change', (event) => this.promoCodeInputControl.call(this, event));
        this.promoCodeInput.off('input').on('input', (event) => this.promoCodeInputControl.call(this, event));

        this.bonusesRemove.off('click').on('click', (event) => this.onBonusesRemove.call(this, event));
        this.promoCodeRemove.off('click').on('click', (event) => this.onPromoCodeRemove.call(this, event));
    }
    onBonusesInput(event) {
        let originalKey = event.keyCode || event.which,
            regexp = /[0-9]|\./,
            key;

        key = String.fromCharCode(originalKey);

        if (!regexp.test(key)) {
            if (parseInt(originalKey) === 13) {
                return this.bonusesForm.submit();
            }

            event.returnValue = false;
            event.preventDefault();
        }
    }
    checkBonusesValue(event) {
        if (parseInt(this.bonusesInput.val()) > this.MAX_BONUSES) {
            this.bonusesInput.val(this.MAX_BONUSES);

            event.returnValue = false;
            event.preventDefault();
        }
    }
    BonusesInputControl() {
        let $this = this;
        if (this.bonusesInput && this.bonusesInput.length) {
            if (!parseInt(this.bonusesInput.val())) {
                $this.bonusesSubmit.attr('disabled', 'disabled');
            } else {
                $this.bonusesSubmit.removeAttr('disabled');
            }
        }
    }
    onBonusesSubmit(event) {
        event.preventDefault();

        let $this = this;

        $this.submit(
            $this.bonusesInput,
            '/ajax/order/lock_bonuses/',
            () => $this.wrapper.trigger('mario.bonuses.withdrawn'),
            true
        );
    }
    promoCodeInputControl() {
        let $this = this;
        
        if (!$this.promoCodeInput.length) {
            return;
        }

        if ($this.promoCodeInput.val().length < 3) {
            $this.promoCodeSubmit.attr('disabled','disabled');
        }
        else {
            $this.promoCodeSubmit.removeAttr('disabled');
        }
    }
    onPromoCodeSubmit(event) {
        event.preventDefault();

        let $this = this;

        $this.submit(
            $this.promoCodeInput,
            '/ajax/order/apply_coupon/',
            () => $this.wrapper.trigger('mario.promo_code.set')
        );
    }
    submit(item, path, callback, checkLikeNumber = false) {
        this.removeInputError(item);

        let $this = this,
            wrapper = item.closest('.' + this.BUTTONS_WRAPPER_CLASS),
            value = item.val();

        if (!value || ((checkLikeNumber && parseInt(value) <= 0) || value.length <= 0)) {
            $this.setInputError(item);

            return;
        }

        $('body').preloader('show');

        $.post(path, {value: value}, (result) => {
            if (result.type !== 'success') {
                $this.setInputError(item, result.value);

                $('body').preloader('hide');

                return;
            }

            wrapper.addClass('done');

            window.refreshHeaderBasket();

            if (callback) {
                callback();
            }
        }, 'json');
    }
    onBonusesRemove(event) {
        event.preventDefault();

        let $this = this;

        this.remove(
            '/ajax/order/remove_bonuses/',
            () => $this.wrapper.trigger('mario.bonuses.removed')
        );
    }
    onPromoCodeRemove(event) {
        event.preventDefault();

        let $this = this;

        this.remove(
            '/ajax/order/remove_coupon/',
            () => $this.wrapper.trigger('mario.promo_code.removed')
        );
    }
    remove(path, callback) {
        $('body').preloader('show');

        $.post(path, {}, () => {
            window.refreshHeaderBasket();

            callback();
        }, 'json');
    }
    setInputError(input, error) {
        let wrapper = input.closest('.' + this.WRAPPER_CLASS);

        wrapper.addClass(this.ERROR_WRAPPER_CLASS);

        wrapper.find('.' + this.ERROR_TEXT_BLOCK).text(error);
    }
    removeInputError(input) {
        input.closest('.' + this.WRAPPER_CLASS).removeClass(this.ERROR_WRAPPER_CLASS);
    }
}
